import React, { Component, Fragment } from 'react';
import logo from '../images/drapcode-logo-bluegreen.svg';
import ErrorForm from '../features/common/ErrorForm';
const imageStyle = {
  height: 40,
  margin: '40px auto',
  display: 'block',
};
export default class ErrorBoundary extends Component {
  state = {
    hasError: false,
    error: { message: '', stack: '' },
    info: { componentStack: '' },
  };

  static getDerivedStateFromError = error => {
    return { hasError: true };
  };
  componentDidCatch(error, info) {
    this.setState({
      error,
      info,
    });
  }

  showErrorOnUI = () => {
    const { hasError } = this.state;

    if (hasError) {
      return (
        <div id="error-page">
          <div className="row">
            <div className="col-2"></div>

            <div className="col-8">
              <div className="row mx-auto">
                <div className="card">
                  <div className="card-body">
                    <img src={logo} style={imageStyle} />
                    <h1>Unfortunately, something has gone wrong.</h1>
                    <p>
                      We're unable to fulfill your request. Rest assured we have been notified and
                      are looking into the issue. Please refresh your browser. If the error
                      continues, please contact our{' '}
                      <a href="https://community.drapcode.com" target="_blank">
                        <b>support team</b>
                      </a>
                      .
                    </p>
                    <p>If you'd like to help, tell us what happend below.</p>
                    <ErrorForm />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-2"></div>
          </div>
        </div>
      );
    } else {
      const { children } = this.props;
      console.log('children :>> ', children);
      return children;
    }
  };

  render() {
    return <Fragment>{this.showErrorOnUI()}</Fragment>;
  }
}
